import React from "react";
import Button from "./Button";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { FiDownloadCloud } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { clearButtonProcessing, setButtonProcessing } from "../../store/actions";
import { useFileDownloader } from "../../hooks";

const ButtonDownloadFile = ({ params, url, ...rest }) => {
  const dispatch = useDispatch();
  const { downloadFileFromPath } = useFileDownloader();
  const handleDownload = () => {
    dispatch(setButtonProcessing(rest?.id));
    downloadFileFromPath(url, params).finally(() => {
    dispatch(clearButtonProcessing(rest?.id));
    });
  };
  return (
    <Button
      theme={tenkenTheme.button}
      color="primary"
      type="button"
      onClick={() => handleDownload()}
      className="lg:h-10 h-[38px] xl:w-[240px] w-[210px] rounded-[6px] z-0"
      {...rest}
    >
      <FiDownloadCloud className="lg:h-5 lg:w-5 h-[18px] w-[18px]" />
      <span className="ml-1 whitespace-nowrap">ファイルダウンロード</span>
    </Button>
  );
};

export default ButtonDownloadFile;
